export enum OrderPageType {
  NEW = 'new',
  READY = 'ready',
  PAST = 'past',
  ALL = 'all',
}
